import { useTranslation } from 'react-i18next'
import { Copy, Reply, BookmarkPlus, Flag } from 'lucide-react'
import { BottomSheet } from '@tendbot/ui'

interface MessageContextMenuProps {
  open: boolean
  onClose: () => void
  onCopy: () => void
  onReply: () => void
  onSaveToNotebook: () => void
  onFlag: () => void
}

interface Action {
  key: string
  icon: React.ComponentType<{ size?: number; className?: string }>
  label: string
  onClick: () => void
  tone?: 'default' | 'danger'
}

export default function MessageContextMenu({
  open,
  onClose,
  onCopy,
  onReply,
  onSaveToNotebook,
  onFlag,
}: MessageContextMenuProps) {
  const { t } = useTranslation('chat')

  const run = (handler: () => void) => () => {
    handler()
    onClose()
  }

  const actions: Action[] = [
    { key: 'copy', icon: Copy, label: t('contextMenu.copy'), onClick: run(onCopy) },
    { key: 'reply', icon: Reply, label: t('contextMenu.reply'), onClick: run(onReply) },
    { key: 'save', icon: BookmarkPlus, label: t('contextMenu.saveToNotebook'), onClick: run(onSaveToNotebook) },
    { key: 'flag', icon: Flag, label: t('contextMenu.flagConversation'), onClick: run(onFlag), tone: 'danger' },
  ]

  return (
    <BottomSheet
      open={open}
      onOpenChange={(o) => { if (!o) onClose() }}
      title={t('contextMenu.title')}
    >
      <div className="px-3 pt-1 pb-5">
        <ul className="flex flex-col">
          {actions.map((action, i) => {
            const Icon = action.icon
            const danger = action.tone === 'danger'
            return (
              <li key={action.key}>
                <button
                  onClick={action.onClick}
                  className={`w-full flex items-center gap-3 px-3 py-3.5 rounded-xl transition-colors text-left ${
                    danger
                      ? 'text-rose hover:bg-rose/10'
                      : 'text-ivory/90 hover:bg-white/[0.04]'
                  }`}
                >
                  <Icon size={18} className={danger ? 'text-rose' : 'text-gold/80'} />
                  <span className="text-sm">{action.label}</span>
                </button>
                {i < actions.length - 1 && (
                  <div className="mx-3 h-px bg-white/5" />
                )}
              </li>
            )
          })}
        </ul>
      </div>
    </BottomSheet>
  )
}
